export default __webpack_public_path__ + "static/media/01.c94e5cb7.png";